import { MapsAPILoader } from "@agm/core";
import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { MDBModalRef, MDBModalService } from "angular-bootstrap-md";
import {
  InstaCitiCountries,
  InstacitiListings,
  InstaNearByLocality,
  InstaPopularCity,
} from "../instaciti-new.interface";
import { InstacitiNewService } from "../service/instaciti-new.service";

declare function LoadSlider(): any;
declare function Tooltip(): any;

@Component({
  selector: "app-instaciti-listing",
  templateUrl: "./instaciti-listing.component.html",
  styleUrls: ["./instaciti-listing.component.css"],
})
export class InstacitiListingComponent implements OnInit {
  placeholder: string = "Type to search...";
  localityPlaceholder: string = "Type to search...";
  filterData = [];
  headers = [];
  listing: InstacitiListings[];
  backupListing;
  arrFilter = [];
  business: string;
  filterBody: any;
  selectedKeyWord = { Keywd: "", Qry: "" };
  logoURL: string =
    "https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/instaciti-logo.png";
  countries: InstaCitiCountries[] = [];
  location: string;
  locality: string;
  cities = [];
  popularCities: InstaPopularCity[] = [];
  selectedCountry;
  locationDetected: boolean = false;
  nearby: InstaNearByLocality[] = [];
  selectedCity;
  latitude: number;
  longitude: number;
  searchResult: [];
  zoom: number;
  address: string;
  searchText: string;
  private geoCoder;
  modalRef: MDBModalRef;
  heading: string;
  subHeading: string;
  bannerImgURL: string;
  arrSubCat = [];
  arrNat = [];
  arrSpl = [];
  arrFacl = [];
  arrPop = [];
  constructor(
    @Inject(DOCUMENT) private document: any,
    private routeParam: ActivatedRoute,
    public title: Title,
    private service: InstacitiNewService,
    private route: Router,
    private mapsAPILoader: MapsAPILoader
  ) {
    document.body.classList.remove("mat-typography");
    title.setTitle("InstaCiti Portal");
    
  }

  ngOnInit(): void {
    this.loadToolTipJS();
    this.fetchURLMetaData();
  }

  fetchURLMetaData() {
    let arrPath = location.pathname.split("/");
    const locn = arrPath[1];
    arrPath.splice(0, 2);
    const keywordURL = arrPath.join("/");
    this.service.getURLMetaData(locn, keywordURL).subscribe((res) => {
      this.selectedKeyWord = res.ManikJSon[0].JSon1[0];
      this.business = this.routeParam.snapshot.params["primaryId"];
      localStorage.setItem(
        "InstaSelectedKeyword",
        JSON.stringify(this.selectedKeyWord)
      );
      if (locn === "near-me") {
        localStorage.removeItem("InstaSelectedCity");
        this.searchText = locn;
        this.setCurrentLocation();
      } else {
        this.selectedCity = res.ManikJSon[0].JSon0[0];
        this.searchText = this.selectedCity.LocName;
        localStorage.setItem(
          "InstaSelectedCity",
          JSON.stringify(this.selectedCity)
        );
        this.checkLocalStorage();
      }
    });
  }

  FetchBusiness() {
    const city = this.locationDetected
      ? this.selectedCountry.CountryName
      : this.selectedCity.City;
    const locality = this.locationDetected
      ? this.selectedCountry.CountryName
      : this.selectedCity.Locality;
    switch (this.business) {
      case "restaurant":
        this.heading = "Discover the best food & drinks in " + city;
        this.subHeading =
          "Explore curated lists of top restaurants, cafes, pubs, and bars in " +
          (locality ? locality : city) +
          " based on trends.";
        this.bannerImgURL =
          "https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/restaurant-hero.png";
        break;
      case "beauty-and-spa":
      case "beauty-spa":
        this.heading = "Discover the best Beauty & Spa in " + city;
        this.subHeading =
          "Explore curated lists of top beauty & spa businesses in " +
          (locality ? locality : city) +
          " based on trends.";
        this.bannerImgURL =
          "https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/beauty-spa-hero.png";
        break;
      case "education":
        this.heading = "Discover the best Schools in " + city;
        this.subHeading =
          "Explore curated lists of top Schools in " +
          (locality ? locality : city) +
          " based on trends.";
        this.bannerImgURL = "assets/img/school-hero.png";
        break;
      case "doctor-clubs":
        this.heading = "Discover the best Automobiles in " + city;
        this.subHeading =
          "Explore curated lists of top Automobiles in " +
          (locality ? locality : city) +
          " based on trends.";
        this.bannerImgURL = "https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/automobiles-hero.png";
        break;
      case "real-estate":
          this.heading = "Discover the best Properties in " + city;
          this.subHeading =
            "Explore curated lists of top Properties in " +
            (locality ? locality : city) +
            " based on trends.";
          this.bannerImgURL = "https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/automobiles-hero.png";
          break;

      case "automative":
        this.heading = "Discover the best Automotives in " + city;
        this.subHeading =
          "Explore curated lists of top Automotives in " +
          (locality ? locality : city) +
          " based on trends.";
        this.bannerImgURL = "https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/automobiles-hero.png";
        break;
      default:
        this.heading = "Discover the best Businesses in " + city;
        this.subHeading =
          "Explore curated lists of top businesses in " +
          (locality ? locality : city) +
          " based on trends.";
        this.bannerImgURL =
          "https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/all-business-hero.png";
        break;
    }
  }
  checkParams() {
    this.business = this.routeParam.snapshot.params["primaryId"]
      ? this.routeParam.snapshot.params["primaryId"]
      : "";
    this.searchText = this.routeParam.snapshot.params["locality"]
      ? this.routeParam.snapshot.params["locality"]
      : "";
    // this.searchText = this.searchText.replace("-", " ");
    this.location = this.searchText;
    if (this.searchText === "near-me") {
      this.checkLocalStorage();
    } else {
      this.fetchURLMetaData();
    }
  }
  checkLocalStorage() {
    if (this.searchText === "near-me") {
      this.setCurrentLocation();
    } else {
      this.selectedCountry = JSON.parse(
        localStorage.getItem("InstaSelectedCountry")
      );
      this.selectedCity = JSON.parse(localStorage.getItem("InstaSelectedCity"));
      let keyWord = JSON.parse(localStorage.getItem("InstaSelectedKeyword"));
      if (this.selectedCountry) {
        sessionStorage.setItem(
          "PortalDS",
          this.selectedCountry.CountryDBContext
        );
        this.service.GetPopularCities(this.selectedCountry).subscribe((res) => {
          this.popularCities = res.ManikJSon[0].JSon0;
        });
        const city: string = this.selectedCity.URLName;
        if (
          this.selectedCity &&
          city.toLowerCase() === this.searchText.toLowerCase()
        ) {
          this.mapKeyword(keyWord);
        } else {
          this.service
            .getLocationMetaData(this.searchText.replace("-", " "))
            .subscribe((res) => {
              this.selectedCity = res.ManikJSon[0].JSon0[0];
              this.mapKeyword(keyWord);
            });
        }
      } else {
        this.getCountries(keyWord);
      }
    }
  }
  mapKeyword(keyWord) {
    let kwrd = this.routeParam.snapshot.params["primaryId"]
      ? this.routeParam.snapshot.params["primaryId"]
      : "";
    kwrd += this.routeParam.snapshot.params["secId"]
      ? "/" + this.routeParam.snapshot.params["secId"]
      : "";
    kwrd += this.routeParam.snapshot.params["tertId"]
      ? "/" + this.routeParam.snapshot.params["tertId"]
      : "";
    if (keyWord && keyWord.URL.toLowerCase() === kwrd.toLowerCase()) {
      this.selectedKeyWord = keyWord;
      this.fetchScreenData();
    } else {
      this.service
        .SearchByKeyword(
          this.selectedCity ? this.selectedCity : this.selectedCountry,
          this.business
        )
        .subscribe((res) => {
          this.selectedKeyWord = res.ManikJSon[0].JSon0.find((val) => {
            return val.URL.toLowerCase().includes(this.business.toLowerCase());
          });
          localStorage.setItem(
            "InstaSelectedKeyword",
            JSON.stringify(this.selectedKeyWord)
          );
          this.fetchScreenData();
        });
    }
  }
  fetchScreenData() {
    this.service.setSelectedCity(
      this.selectedCity ? this.selectedCity : this.selectedCountry
    );
    this.FetchBusiness();
    this.getFiltersData(
      this.selectedCity ? this.selectedCity : this.selectedCountry
    );
    this.searchBusiness(
      this.selectedCity ? this.selectedCity : this.selectedCountry
    );
  }
  loadToolTipJS() {
    setTimeout(() => {
      Tooltip();
    }, 400);
  }
  getFiltersData(city) {
    this.service
      .GetFilterData(city, this.routeParam.snapshot.params["primaryId"] || "")
      .subscribe((res) => {
        const category = JSON.parse(res.ManikJSon[0].JSon0[0].FilterJson);
        console.log(category);
        this.filterData = category.CatJson;
        this.filterData.forEach((element, idx) => {
          this.headers = this.headers.concat(Object.keys(element));
          if (element[Object.keys(element)[0]].length) {
            element[Object.keys(element)[0]].forEach((val) => {
              switch (idx) {
                case 0:
                  val.checked = this.arrSubCat.includes(val.ID.toString());
                  break;
                case 1:
                  val.checked = this.arrNat.includes(val.ID.toString());
                  break;
                case 2:
                  val.checked = this.arrSpl.includes(val.ID.toString());
                  break;
                case 3:
                  val.checked = this.arrFacl.includes(val.ID.toString());
                  break;
                case 4:
                  val.checked = this.arrPop.includes(val.ID.toString());
                  break;
                default:
                  break;
              }
            });
          }
        });
      });
  }

  openURL(data: string) {
    let url  = `https://biz.bizcard.world/${data}`
    window.open(url, "_blank");
  }
  filter(event: any, idx) {
    switch (idx) {
      case 0:
        if (event.target.checked && event.target.id > -1) {
          this.arrSubCat.push(event.target.id);
          if (this.arrSubCat.length > 1 && this.arrSubCat.includes("0")) {
            this.arrSubCat.splice(this.arrSubCat.indexOf("0"), 1);
          }
        } else if (event.target.id > -1) {
          this.arrSubCat.splice(this.arrSubCat.indexOf(event.target.id), 1);
          if (!this.arrSubCat.length) {
            this.arrSubCat.push("0");
          }
        }
        break;
      case 1:
        if (event.target.checked && event.target.id > -1) {
          this.arrNat.push(event.target.id);
          if (this.arrNat.length > 1 && this.arrNat.includes("0")) {
            this.arrNat.splice(this.arrNat.indexOf("0"), 1);
          }
        } else if (event.target.id > -1) {
          this.arrNat.splice(this.arrNat.indexOf(event.target.id), 1);
          if (!this.arrNat.length) {
            this.arrNat.push("0");
          }
        }
        break;
      case 2:
        if (event.target.checked && event.target.id > -1) {
          this.arrSpl.push(event.target.id);
          if (this.arrSpl.length > 1 && this.arrSpl.includes("0")) {
            this.arrSpl.splice(this.arrSpl.indexOf("0"), 1);
          }
        } else if (event.target.id > -1) {
          this.arrSpl.splice(this.arrSpl.indexOf(event.target.id), 1);
          if (!this.arrSpl.length) {
            this.arrSpl.push("0");
          }
        }
        break;
      case 3:
        if (event.target.checked && event.target.id > -1) {
          this.arrFacl.push(event.target.id);
          if (this.arrFacl.length > 1 && this.arrFacl.includes("0")) {
            this.arrFacl.splice(this.arrFacl.indexOf("0"), 1);
          }
        } else if (event.target.id > -1) {
          this.arrFacl.splice(this.arrFacl.indexOf(event.target.id), 1);
          if (!this.arrFacl.length) {
            this.arrFacl.push("0");
          }
        }
        break;
      case 4:
        if (event.target.checked && event.target.id > -1) {
          this.arrPop.push(event.target.id);
          if (this.arrPop.length > 1 && this.arrPop.includes("0")) {
            this.arrPop.splice(this.arrPop.indexOf("0"), 1);
          }
        } else if (event.target.id > -1) {
          this.arrPop.splice(this.arrPop.indexOf(event.target.id), 1);
          if (!this.arrPop.length) {
            this.arrPop.push("0");
          }
        }
        break;
      default:
        break;
    }
    let city = this.selectedCity ? this.selectedCity : this.selectedCountry;
    this.filterBody = {
      PgSize: "10",
      PgNo: "0",
      SortCol: "BusinessTitle",
      SortOrder: "DESC",
      Lat: city.Latitude,
      Long: city.Longitude,
      Radius: 30,
      Cat: this.arrFilter[0],
      SubCat: this.arrSubCat.length ? this.arrSubCat.join(",") : "0",
      Price: 100000,
      PopCSV: this.arrPop.length ? this.arrPop.join(",") : "0",
      SplCSV: this.arrSpl.length ? this.arrSpl.join(",") : "0",
      FacilityCSV: this.arrFacl.length ? this.arrFacl.join(",") : "0",
      NatureCSV: this.arrNat.length ? this.arrNat.join(",") : "0",
      Rating: 4,
    };
    this.service
      .getNearByBiz({
        items: [this.filterBody],
      })
      .subscribe((res1) => {
        const tempListing = res1.ManikJSon[0].JSon0;
        tempListing.forEach((element) => {
          if (element.PopularAttribs) {
            element.PopularAttribs = JSON.parse(element.PopularAttribs);
            element.PopularAttribs.forEach((element1, idx) => {
              if (element1.ID === "CUISINES") {
                if (element1.D.trim()) {
                  element1.D = element1.D.split(",");
                } else {
                  element.PopularAttribs.splice(idx);
                }
              }
            });
          }
        });
        this.listing = tempListing;
        this.backupListing = JSON.stringify(this.listing);
      });
  }

  searchBusiness(city) {
    if (this.selectedKeyWord) {
      this.arrFilter = this.selectedKeyWord.Qry.split("_");
      this.arrSubCat = [this.arrFilter[1]];
      this.arrSpl = [this.arrFilter[3]];
      this.arrFacl = [this.arrFilter[2]];
      this.filterBody = {
        PgSize: "10",
        PgNo: "0",
        SortCol: "BusinessTitle",
        SortOrder: "DESC",
        Lat: city.Latitude,
        Long: city.Longitude,
        Radius: 30,
        Cat: this.arrFilter[0],
        SubCat: this.arrFilter[1],
        Price: 100000,
        PopCSV: "0",
        SplCSV: this.arrFilter[3],
        FacilityCSV: this.arrFilter[2],
        NatureCSV: "0",
        Rating: 4,
      };
      this.service
        .getNearByBiz({
          items: [this.filterBody],
        })
        .subscribe((res1) => {
          const tempListing = res1.ManikJSon[0].JSon0;
          tempListing.forEach((element) => {
            if (element.PopularAttribs) {
              element.PopularAttribs = JSON.parse(element.PopularAttribs);
              element.PopularAttribs.forEach((element1, idx) => {
                if (element1.ID === "CUISINES") {
                  if (element1.D.trim()) {
                    element1.D = element1.D.split(",");
                  } else {
                    element.PopularAttribs.splice(idx);
                  }
                }
              });
            }
          });
          this.listing = tempListing;
          this.backupListing = JSON.stringify(this.listing);
        });
    }
  }

  selectCountry(country, onLoad = false) {
    this.selectedCountry = country;
    this.service.setSelectedCountry(this.selectedCountry);
    sessionStorage.setItem("PortalDS", this.selectedCountry.CountryDBContext);
    this.service.GetPopularCities(country).subscribe((res) => {
      this.popularCities = res.ManikJSon[0].JSon0;
    });
    if (onload) {
      this.mapKeyword(JSON.parse(localStorage.getItem("InstaSelectedKeyword")));
    }
  }

  getCountries(keyWord) {
    this.service.GetCountries().subscribe((res) => {
      this.countries = res.ManikJSon[0].JSon0;
      this.service
        .getLocationMetaData(this.searchText.replace("-", " "))
        .subscribe((res1) => {
          const city: string = this.selectedCity
            ? this.selectedCity.CityName
              ? this.selectedCity.CityName
              : this.selectedCity.LocName
            : "";
          if (
            this.selectedCity &&
            city.toLowerCase() === this.searchText.toLowerCase()
          ) {
            this.mapKeyword(keyWord);
          } else {
            this.selectedCity = res1.ManikJSon[0].JSon0[0];
            this.mapKeyword(keyWord);
          }
          const country = this.countries.find(
            (c) => c.CountryID === this.selectedCity.CountryID
          );
          this.selectCountry(country);
        });
    });
  }
  setCurrentLocation() {
    this.service.GetCountries().subscribe((res) => {
      this.countries = res.ManikJSon[0].JSon0;
      this.mapsAPILoader.load().then(() => {
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.locationDetected = true;
            localStorage.setItem("near-me", "1");
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            this.zoom = 8;
            this.getAddress(this.latitude, this.longitude);
          });
        }
        this.geoCoder = new google.maps.Geocoder();
      });
    });
  }
  getAddress(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === "OK") {
          console.log(results);
          if (results[0]) {
            this.zoom = 12;
            this.address = results[0].formatted_address;
            var arr = this.address.split(",");
            if (arr.length) {
              this.selectCountry(
                this.countries.find((c) =>
                  c.CountryName.includes(arr[arr.length - 1].trim())
                ),
                true
              );
            } else {
              this.selectCountry(
                this.countries.find((c) => c.CountryID === 100000),
                true
              );
            }
            if (arr.length > 1) {
              this.searchText = arr[arr.length - 2].concat(
                ",",
                arr[arr.length - 1]
              );
            } else {
              this.searchText = this.address;
            }
            this.location = this.searchText;
            this.locality = "";
          } else {
            window.alert("No results found");
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      }
    );
  }
  getNearBy() {
    this.service
      .GetNearByLocalities({
        CountryID: this.selectedCountry.CountryID,
        Latitude: this.latitude ? this.latitude : this.selectedCountry.Latitude,
        Longitude: this.longitude
          ? this.longitude
          : this.selectedCountry.Longitude,
        portalds: this.selectedCountry.CountryDBContext,
        SearchText: this.searchText || "",
      })
      .subscribe((res) => {
        this.nearby = res.ManikJSon[0].JSon0.length
          ? res.ManikJSon[0].JSon0.slice(0, 20)
          : [];
      });
  }
  focus(event: any) {
    this.placeholder = this.selectedKeyWord.Keywd
      ? this.selectedKeyWord.Keywd
      : "Type to search...";
    this.selectedKeyWord.Keywd = "";
    this.search(event);
  }
  focusLocation() {
    this.localityPlaceholder = this.searchText
      ? this.searchText
      : "Type to search...";
    this.searchText = "";
    this.getNearBy();
  }
  search(event: any) {
    const keyword = event.target.value;
    this.service
      .SearchByKeyword(
        this.selectedCity ? this.selectedCity : this.selectedCountry,
        keyword.trim()
      )
      .subscribe((res) => {
        this.searchResult = res.ManikJSon[0].JSon0.length
          ? res.ManikJSon[0].JSon0.slice(0, 50)
          : [];
      });
  }

  detectCurrentLocation() {
    let arrPath = location.pathname.split("/");
    arrPath.splice(0, 2);
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl("near-me/" + arrPath);
  }

  selectNearByCity(city) {
    localStorage.removeItem("near-me");
    this.locationDetected = false;
    this.selectedCity = city;
    this.service.setSelectedCity(this.selectedCity);
    this.location = city.City;
    this.locality = city.Locality;
    this.searchText = city.LocName;
    let locn = location.pathname.replace(
      this.routeParam.snapshot.params["locality"],
      this.selectedCity.URLName.trim()
    );
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl(locn);
  }
  selectPopularCity(city) {
    localStorage.removeItem("near-me");
    this.locationDetected = false;
    this.selectedCity = city;
    this.service.setSelectedCity(this.selectedCity);
    this.location = city.CityName;
    this.locality = city.Locality;
    this.searchText = city.LocName;
    let locn = location.pathname.replace(
      this.routeParam.snapshot.params["locality"],
      this.selectedCity.URLName.trim()
    );
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl(locn);
  }
  onChange(item) {
    this.selectedKeyWord = item;
    localStorage.setItem("InstaSelectedKeyword", JSON.stringify(item));
    if (item.Tgt === "S") {
      this.route.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };
      this.route.navigateByUrl(
        (this.locationDetected ? "near-me" : this.selectedCity.URLName.trim()) +
          "/" +
          item.URL
      );
    } else if (item.Tgt === "N") {
      this.GoToBizSpot(item.URL);
    }
  }
  GoToBizSpot(url) {
    window.open(url, "_blank");
  }
  openSchool(handle: string) {
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl(
      this.searchText + "/" + this.business + "/" + handle
    );
  }
  
}
